import Notification from "@Features/notification/components/Notification";
import React from "react";

interface InputProps {
    "htmlId": string,
    "value": any,
    "onChange": (...args: any[]) => any,
    "onBlur"?: (...args: any[]) => any,
    "onFocus"?: (any) => any,
    "onKeyDown"?: (...args: any[]) => any,
    "type"?: string,
    "placeholder"?: string,
    "isRequired"?: boolean,
    "inputClassName"?: string,
    "showError"?: boolean,
    "errorMessage"?: string | React.ReactNode
}

function Input(props: InputProps) {
    const {
        inputClassName,
        htmlId,
        type,
        onChange,
        onKeyDown,
        value,
        placeholder,
        onBlur,
        onFocus,
        isRequired,
        showError,
        errorMessage,
    } = props
    return (
        <>
            <input
                className={inputClassName}
                id={htmlId}
                type={type}
                name={htmlId}
                onChange={onChange}
                onKeyDown={onKeyDown}
                onFocus={onFocus}
                value={value}
                placeholder={placeholder}
                onBlur={onBlur}
                required={isRequired}
            />

            {showError && (
                <Notification notificationType="orange">
                    {errorMessage}
                </Notification>
            )}
        </>
    );
}

export default Input